export const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function sanitizeCategory(cat: string | null | undefined): string {
  if (!cat) return '';
  return UUID_PATTERN.test(cat.trim()) ? '' : cat;
}
